import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  Grid,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TextInput from "./TextInput";
import { languageIcons, languageMapping } from "../../config/localization";

const LocalizedInput = ({
  label,
  value = {},
  onChange,
  multiline = false,
  rows = 2,
  variant = "default",
  disabled = false,
}) => {
  const [expanded, setExpanded] = useState(true); // Accordion open by default

  const handleInputChange = (lang) => (e) => {
    onChange({ ...value, [lang]: e.target.value });
  };

  if (variant === "modern") {
    return (
      <Box component="fieldset" sx={{ border: 0, m: 0, p: 0, minWidth: 0 }}>
        <Typography
          component="legend"
          variant="body2"
          fontWeight={600}
          sx={{ mb: 1, p: 0 }}
        >
          {label}
        </Typography>
        <Stack spacing={1.5}>
          {languageMapping.map((map, idx) => (
            <Grid
              key={`input-${map.code}-${idx}`}
              container
              spacing={1.5}
              alignItems="center"
            >
              <Grid size={{ xs: 3, sm: 2 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Box
                    component="span"
                    aria-hidden="true"
                    sx={{ display: "inline-flex" }}
                  >
                    {languageIcons[map.code]}
                  </Box>
                  <Typography
                    fontWeight={500}
                    variant="overline"
                    sx={{ lineHeight: 1 }}
                  >
                    {map.code.toUpperCase()}
                  </Typography>
                </Stack>
              </Grid>
              <Grid size={{ xs: 9, sm: 10 }}>
                <TextInput
                  inputProps={{
                    "aria-label": `${label} (${map.code.toUpperCase()})`,
                  }}
                  value={value[map.source] || ""}
                  onChange={handleInputChange(map.source)}
                  multiline={multiline}
                  rows={rows}
                  disabled={disabled}
                />
              </Grid>
            </Grid>
          ))}
        </Stack>
      </Box>
    );
  }

  return (
    <Accordion
      expanded={expanded}
      sx={{ mt: 2 }}
      onChange={() => setExpanded(!expanded)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography fontWeight={600}>{label}</Typography>
      </AccordionSummary>

      <AccordionDetails>
        {/* Language Tabs */}
        <Box sx={{ mb: 2 }}>
          {languageMapping.map((map, idx) => {
            return (
              <Grid
                key={`input-${map.code}-${idx}`}
                container
                spacing={1}
                alignItems="center"
              >
                <Grid size={{ xs: 1 }}>
                  <Stack direction={"row"} spacing={1} alignItems={"center"}>
                    <Box
                      component="span"
                      aria-hidden="true"
                      sx={{ display: "inline-flex" }}
                    >
                      {languageIcons[map.code]}
                    </Box>
                    <Typography
                      fontWeight={500}
                      variant="overline"
                      gutterBottom
                      sx={{ display: "block" }}
                    >
                      {map.code.toUpperCase()}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid size={{ xs: 11 }} p={0.5}>
                  <TextInput
                    inputProps={{
                      "aria-label": `${label} (${map.code.toUpperCase()})`,
                    }}
                    value={value[map.source] || ""}
                    onChange={handleInputChange(map.source)}
                    multiline={multiline}
                    rows={rows}
                  />
                </Grid>
              </Grid>
            );
          })}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default LocalizedInput;
